import { render, staticRenderFns } from "./chapterHeading.vue?vue&type=template&id=1ee5de5e&scoped=true&"
import script from "./chapterHeading.vue?vue&type=script&lang=js&"
export * from "./chapterHeading.vue?vue&type=script&lang=js&"
import style0 from "./chapterHeading.vue?vue&type=style&index=0&id=1ee5de5e&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee5de5e",
  null
  
)

export default component.exports